import {domainMonitorAPI} from 'features/domain/api/domainMonitorAPI';
import {useUpdateMonitorTags} from 'entities/monitor';

export const useUpdateDomainMonitorTags = (uuid: string | undefined) => {
    const [updateDomainMonitor] = domainMonitorAPI.useUpdateDomainMonitorMutation();

    return useUpdateMonitorTags(updateDomainMonitor, uuid);
};

export default useUpdateDomainMonitorTags;
